import React from 'react';
import image1 from "../../assets/school.png";
import image2 from "../../assets/school2.png";
import image3 from "../../assets/school3.png";
import { Carousel } from 'react-responsive-carousel';
import bgimage from "../../assets/school-bg.png";
import { motion } from 'framer-motion';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import CartButton from '../CartButton';

const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
};

const buttonVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5, delay: 0.5 } }
};

const imageVariants = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0, transition: { duration: 1.5 } }
};

function SchoolHero() {
    const images = [
        { src: image1, alt: 'BG1' },
        { src: image2, alt: 'BG2' },
        { src: image3, alt: 'BG3' },
    ];

    return (
        <section>
            <div className="relative bg-cover bg-center bg-no-repeat min-h-screen">
                <img src={bgimage} alt="Background" className="absolute opacity-30 inset-0 w-full h-full object-cover" />
                <motion.div
                    className="flex px-6 md:px-20 items-center justify-center bg-hero md:h-screen overflow-hidden relative"
                    initial="hidden"
                    animate="visible"
                >
                    <div className="flex flex-col gap-6 md:flex-row items-center max-w-8xl">
                        <motion.div className="w-full md:w-1/2 lg:pr-32" variants={textVariants}>
                            <h2 className="text-3xl lg:text-6xl text-center md:text-left text-blue-900 leading-tight font-bold lg:-mt-10 mt-2">
                                Your gateway to interactive learning & excellence.
                            </h2>
                            <h3
                                className="mt-6 md:mt-10 text-md lg:text-xl text-center md:text-left text-gray-700 font-light tracking-wider leading-relaxed"
                            >
                                Our Learning Management System (LMS) is designed to provide students, teachers, and parents with seamless access to educational resources, assignments etc. Navigate through the platform to explore a world of knowledge.
                            </h3>
                            <div className="mt-10 flex flex-col sm:flex-row justify-center md:justify-start">
                                <motion.button
                                    className="w-full sm:w-40 px-4 py-3 rounded font-semibold text-md bg-blue-500 text-white border-2 border-blue-500"
                                    variants={buttonVariants}
                                >
                                    Get started
                                </motion.button>
                                <motion.button
                                    className="w-full mt-4 sm:mt-0 sm:ml-4 sm:w-40 px-2 py-3 rounded font-semibold text-md bg-white text-blue-500 border border-gray-400/70 shadow-md shadow-gray-400/80"
                                    variants={buttonVariants}
                                >
                                    Schedule a Demo
                                </motion.button>
                            </div>
                        </motion.div>
                        <motion.div className="w-full md:w-1/2 flex justify-center md:justify-end" variants={imageVariants}>
                            <Carousel
                                showThumbs={false}
                                showStatus={false}
                                showIndicators={false}
                                autoPlay
                                showArrows={false}
                                interval={2000}
                                infiniteLoop
                            >
                                {images.map((image, index) => (
                                    <div key={index}>
                                        <img src={image.src} alt={image.alt} />
                                    </div>
                                ))}
                            </Carousel>
                        </motion.div>
                    </div>
                </motion.div>
            </div>

            <CartButton />
        </section>
    );
}

export default SchoolHero;
